import { handleError } from "@/utils/common";
import { formatTel } from "@/utils/format";
import { getContactInfo } from "@/api/common";

const commonStore = {
    namespaced: true,
    state: {
        mainTel: "",
        footerTel: "",
        footerEmail: "",
    },
    getters: {
        mainTel(state) {
            return state.mainTel;
        },
        footerTel(state) {
            return state.footerTel;
        },
        footerEmail(state) {
            return state.footerEmail;
        },
    },
    mutations: {
        SET_MAIN_TEL(state, mainTel) {
            state.mainTel = formatTel(mainTel);
        },
        SET_FOOTER_TEL(state, footerTel) {
            state.footerTel = formatTel(footerTel);
        },
        SET_FOOTER_EMAIL(state, footerEmail) {
            state.footerEmail = formatTel(footerEmail);
        },
    },
    actions: {
        async FETCH_CONTACT_INFO({ state, commit }) {
            if (!state.mainTel || !state.footerTel || !state.footerEmail) {
                try {
                    const { data } = await getContactInfo();
                    commit("SET_MAIN_TEL", data.data.mainTel);
                    commit("SET_FOOTER_TEL", data.data.footerTel);
                    commit("SET_FOOTER_EMAIL", data.data.footerEmail);
                } catch (error) {
                    handleError(error);
                }
            }
        },
    },
};

export default commonStore;
